import * as React from "react";

const PageNotFound = () => {
  return (
      <section className="flex items-center h-full p-16 bg-coolGray-50 text-coolGray-800">
        <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
          <div className="max-w-md text-center">
            <h2 className="mb-8 font-extrabold text-9xl text-coolGray-400">
              <span className="sr-only">Error </span>404
            </h2>
            <p className="text-2xl font-semibold md:text-3xl text-coolGray-600">
              Sorry, we couldn't find this page.
            </p>
          </div>
        </div>
      </section>
  );
};

export default PageNotFound;
